<template>
  <el-dialog
    :model-value="modelValue"
    title="修改密码"
    width="440px"
    append-to-body
    destroy-on-close
    @update:model-value="emit('update:modelValue', $event)"
    @closed="formRef?.clearValidate()"
  >
    <p class="password-description">修改密码后，所有登录会话将失效，需要使用新密码重新登录。</p>
    <el-form ref="formRef" :model="form" :rules="rules" label-position="right" label-width="120px">
      <el-form-item label="当前密码" prop="currentPassword">
        <el-input v-model="form.currentPassword" type="password" show-password autocomplete="current-password" />
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input v-model="form.newPassword" type="password" show-password autocomplete="new-password" />
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password" show-password autocomplete="new-password" @keyup.enter="submit" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="emit('update:modelValue', false)">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">保存新密码</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { reactive, ref, watch } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'

const props = defineProps<{ modelValue: boolean; submitting?: boolean }>()
const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  save: [payload: { currentPassword: string; newPassword: string }]
}>()

const formRef = ref<FormInstance>()
const form = reactive({ currentPassword: '', newPassword: '', confirmPassword: '' })
const rules: FormRules = {
  currentPassword: [{ required: true, message: '请输入当前密码', trigger: 'blur' }],
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 8, max: 72, message: '新密码长度需为 8-72 位', trigger: 'blur' },
  ],
  confirmPassword: [
    { required: true, message: '请再次输入新密码', trigger: 'blur' },
    {
      validator: (_rule, value, callback) => value === form.newPassword
        ? callback()
        : callback(new Error('两次输入的密码不一致')),
      trigger: 'blur',
    },
  ],
}

watch(() => props.modelValue, (visible) => {
  if (visible) Object.assign(form, { currentPassword: '', newPassword: '', confirmPassword: '' })
})

async function submit() {
  if (!(await formRef.value?.validate().catch(() => false))) return
  emit('save', { currentPassword: form.currentPassword, newPassword: form.newPassword })
}
</script>

<style scoped>
.password-description {
  margin: 0 0 18px;
  color: var(--hy-text-secondary);
  font-size: 13px;
  line-height: 1.6;
}
</style>
